module.exports = __webpack_public_path__ + "img/x-background.c799316.svg";